import React from "react";
import { Link } from "react-router-dom";

function TemplateCard(props) {
    const {name, mediaId, surveyId} = props;

    return (
        <Link className="template__card" to={{pathname: "/survey-templates/" + surveyId, state: {questId:surveyId}}}>
            <div className="template__card__crop_container">
                <img alt={name} src={mediaId ? '/rest/quests/getMedia/' + mediaId : ''} />
            </div>
            <div className="template__card__title">{name}</div>
        </Link>
    );
}

export default TemplateCard;